import fixWebmDurationLib from 'fix-webm-duration'

/** Writes WebM Duration metadata (MediaRecorder streams often omit it). */
export async function fixWebmDuration(blob: Blob, durationMs: number): Promise<Blob> {
	return fixWebmDurationLib(blob, durationMs, { logger: false })
}
